<hotkeys-cheatsheet title="Genvejstaster"></hotkeys-cheatsheet>
<mat-sidenav-container fullscreen>
  <mat-sidenav #drawer class="sidenav" fixedInViewport [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
    [mode]="(isHandset$ | async) ? 'over' : 'side'" [opened]="(isHandset$ | async) === false">
    <mat-toolbar color="primary" class="toolbar" [style]="toolbarStyle$ | async">
      <mat-toolbar-row>
        <button mat-icon-button class="app-title-button" [routerLink]="['/home']">
          <img class="appTitle" src="assets/logo.svg" />
          <div class="appTitle">{{ appTitle$ | async }}</div>
        </button>
      </mat-toolbar-row>
    </mat-toolbar>
    <mat-nav-list class="sidenav-list">
      <cer-app-layout-sidenav></cer-app-layout-sidenav>
    </mat-nav-list>
  </mat-sidenav>
  <mat-sidenav-content class="content-container">
    <mat-toolbar color="primary" [style]="toolbarStyle$ | async">
      <mat-toolbar-row>
        <button type="button" class="sidenav-toggle" aria-label="Vis/skjul menu" mat-icon-button
          (click)="drawer.toggle()">
          <mat-icon aria-label="Vis menu">menu</mat-icon>
        </button>
        <cer-app-layout-route-title></cer-app-layout-route-title>
        <span class="header-row-spacing"></span>
        <cer-login-menu></cer-login-menu>
        <button mat-icon-button [matMenuTriggerFor]="paletteMenu">
          <mat-icon>{{activeThemeIcon$ | async}}</mat-icon>
        </button>
        <mat-menu #paletteMenu="matMenu">
          <button mat-menu-item (click)="selectTheme('dark')">
            <mat-icon>dark_mode</mat-icon>
            <span>Vælg mørkt tema</span>
          </button>
          <button mat-menu-item (click)="selectTheme('light')">
            <mat-icon>light_mode</mat-icon>
            <span>Vælg lyst tema</span>
          </button>
          <button mat-menu-item (click)="selectTheme('device-default')">
            <mat-icon>devices</mat-icon>
            <span>Vælg enhedens tema</span>
          </button>
        </mat-menu>
        <button mat-icon-button [matMenuTriggerFor]="helpmenu">
          <mat-icon>help</mat-icon>
        </button>
        <mat-menu #helpmenu="matMenu">
          <button mat-menu-item (click)="showHelp()" [disabled]="!isHelpActive">
            <mat-icon>help</mat-icon>
            <span>Hjælp</span>
          </button>
          <button mat-menu-item (click)="showAppHelpAbout()">
            <mat-icon>build</mat-icon>
            <span>Om {{ appTitle$ | async }}</span>
          </button>
        </mat-menu>
      </mat-toolbar-row>
    </mat-toolbar>
    <div class="content-router" [ngClass]="routerOverflowClass">
      <router-outlet name="primary" class="content-router-outlet" (activate)="onRouterOutletActivate($event)"
        (deactivate)="onRouterOutletDeactivate($event)"></router-outlet>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>